import React from 'react';
import ReactDOM from 'react-dom';
import 'react-id-swiper/src/styles/css/swiper.css';
import './index.css';
import registerServiceWorker from './registerServiceWorker';

import Perf from 'react-addons-perf'

import {Provider} from 'react-redux';
import configureStore from './store/configureStore';

import RouterMap from './router/RouterMap';

import 'babel-polyfill'

window.Perf = Perf;

const store = configureStore();

ReactDOM.render(
    <Provider store={store}>
        <RouterMap/>
    </Provider>
    , document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js